module.exports = __webpack_public_path__ + "static/media/cq_locazione.48eee83c.svg";